import Vue from 'vue'
import Router from 'vue-router'
// 各route引入
import Home from './home/index'
import About from './about/about';
import Introduction from './introduction/introduction';
import Development from './development/development';
import Service from './service/service';
import Visit from './visit/visit';
import Case from './case/case';
import Contact from './contact/contact';

// 各元件引入
import Layout from '@/components/layout'
// import Home from '@/components/index'


Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            component: Layout,
            children: [
                ...Home,
                ...About,
                ...Introduction,
                ...Development,
                ...Service,
                ...Visit,
                ...Case,
                ...Contact
            ]
            
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js